import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Checkbox } from 'components/atoms/checkbox';
import { Input } from 'components/facade/input';
import { SettingsControlPanel } from 'components/molecules/settings/control-panel';
import { useTranslation } from 'hooks/use-translation';
import { useUpdateSettings } from '../use-feature-setting';
import { CheckBoxWrap, ContentBox, SettingsLineWrapper } from './components';
const StyledInput = styled(Input)`
  width: 200px;
`;
export const CreditNoteNumberSettings = ({ creditNotePrefix, nextCreditNoteNumber, isAllowedToEditCreditNoteNumber })=>{
    const [creditNotePrefixValue, setCreditNotePrefixValue] = useState(creditNotePrefix);
    const [nextCreditNoteNumberValue, setNextCreditNoteNumberValue] = useState(nextCreditNoteNumber);
    const [allowUsersToEditCreditNoteNumber, setAllowUsersToEditCreditNoteNumber] = useState(isAllowedToEditCreditNoteNumber);
    const [update, isLoading] = useUpdateSettings();
    const placeholder = useTranslation('settings.credit_notes.credit_note_number.prefix.placeholder');
    const label = useTranslation('settings.credit_notes.controls.credit_note_number.label');
    const description = useTranslation('settings.credit_notes.controls.credit_note_number.description');
    return /*#__PURE__*/ _jsxs(SettingsControlPanel, {
        label: label,
        descriptions: [
            description
        ],
        children: [
            /*#__PURE__*/ _jsxs(SettingsLineWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(ContentBox, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "settings.credit_notes.credit_note_number.prefix"
                        })
                    }),
                    /*#__PURE__*/ _jsx(StyledInput, {
                        value: creditNotePrefixValue,
                        onChange: (e)=>setCreditNotePrefixValue(e.target.value),
                        placeholder: placeholder,
                        onBlur: ()=>{
                            if (creditNotePrefix !== creditNotePrefixValue) {
                                update({
                                    payload: {
                                        creditNotePrefix: creditNotePrefixValue
                                    },
                                    onError: ()=>{
                                        setCreditNotePrefixValue(creditNotePrefix);
                                    }
                                });
                            }
                        },
                        disabled: isLoading,
                        maxLength: 20
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(SettingsLineWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(ContentBox, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "settings.credit_notes.credit_note_number.next_credit_note_number"
                        })
                    }),
                    /*#__PURE__*/ _jsx(StyledInput, {
                        disabled: isLoading,
                        value: nextCreditNoteNumberValue,
                        onChange: (e)=>setNextCreditNoteNumberValue(e.target.value),
                        onBlur: ()=>{
                            const trimmedNextCreditNoteNumber = (nextCreditNoteNumberValue !== null && nextCreditNoteNumberValue !== void 0 ? nextCreditNoteNumberValue : '').trim();
                            setNextCreditNoteNumberValue(trimmedNextCreditNoteNumber);
                            if (nextCreditNoteNumber !== trimmedNextCreditNoteNumber) {
                                update({
                                    payload: {
                                        nextCreditNoteNumber: trimmedNextCreditNoteNumber
                                    },
                                    onError: ()=>{
                                        setNextCreditNoteNumberValue(nextCreditNoteNumber);
                                    }
                                });
                            }
                        },
                        maxLength: 20
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CheckBoxWrap, {
                children: /*#__PURE__*/ _jsx(Checkbox, {
                    checked: allowUsersToEditCreditNoteNumber,
                    onChange: (e)=>{
                        setAllowUsersToEditCreditNoteNumber(e.target.checked);
                        update({
                            payload: {
                                allowUsersToEditCreditNoteNumber: e.target.checked
                            },
                            onError: ()=>{
                                setAllowUsersToEditCreditNoteNumber(!e.target.checked);
                            }
                        });
                    },
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "settings.credit_notes.credit_note_number.enable_editing"
                    })
                })
            })
        ]
    });
};
